import ActivityType from '../../schema/innerSchema/ActivityType';
import BusStopData from '../../schema/viewSchema/BusStopData';
import Invoice from '../../schema/Invoice';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 * Extracts the lodging specific data needed for displaying the bus stop
 */
export default function populateInvoiceBusStopData(
    invoiceEntity: Invoice,
    activityType: ActivityType,
    amount: string,
    paymentDate: string,
    paymentDateAriaFormat: string,
    customerText: string,
    txpStrings: TxpStrings,
    icon: string
): BusStopData {
    let collapsedText: string;
    let ariaBusStopText: string;
    let ariaCardSummaryFormatString: string;
    let collapsedSummaryFormatString: string;
    let isInvoiceScheduled = activityType == ActivityType.InvoiceScheduled;

    if (amount) {
        ariaCardSummaryFormatString = isInvoiceScheduled
            ? txpStrings.strings.invoiceWithScheduledWholeCardSummaryText
            : txpStrings.strings.invoiceWithDueWholeCardSummaryText;
        collapsedSummaryFormatString = isInvoiceScheduled
            ? txpStrings.strings.invoiceWithScheduledBusStopText
            : txpStrings.strings.invoiceWithDueBusStopText;
    } else {
        ariaCardSummaryFormatString = isInvoiceScheduled
            ? txpStrings.strings.invoiceWithScheduledNoAmountWholeCardSummaryText
            : txpStrings.strings.invoiceWithDueNoAmountWholeCardSummaryText;
        collapsedSummaryFormatString = isInvoiceScheduled
            ? txpStrings.strings.invoiceWithScheduledNoAmountBusStopText
            : txpStrings.strings.invoiceWithDueNoAmountBusStopText;
    }

    collapsedText = txpStrings.formatters.format(
        collapsedSummaryFormatString,
        invoiceEntity.provider.name,
        paymentDate,
        amount
    );

    ariaBusStopText =
        txpStrings.formatters.format(
            ariaCardSummaryFormatString,
            invoiceEntity.provider.name,
            invoiceEntity.accountId,
            paymentDateAriaFormat,
            amount
        ) +
        ' ' +
        customerText;

    return {
        busStopLabel: txpStrings.strings.invoiceLabelText,
        busStopText: txpStrings.formatters.format(
            txpStrings.strings.invoiceBillText,
            invoiceEntity.provider.name
        ),
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
        icon: icon,
    } as BusStopData;
}
